import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseDialogComponent } from '@helpers/base';
import { MessagesThreadListComponent } from '../thread-list/thread-list.component';
import { MESSAGES_ROUTE } from '@pages/messages/symbols';
import { Thread } from '@appbolaget/aware-model';
import { DialogService } from '@viewservices/dialog.service';
import { MessagesChatDialogComponent, MessagesChatDialogData } from '../chat-dialog/chat-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-messages-thread-list-dialog',
    templateUrl: 'thread-list-dialog.component.html',
    standalone: true,
    imports: [MessagesThreadListComponent, MatToolbarModule, MatIconModule, RouterLink],
    styles: [
        `
            :host {
                display: flex;
                flex-direction: column;
                height: 100%;
            }
        `,
    ],
})
export class MessagesThreadListDialogComponent extends BaseDialogComponent {
    messagesRoute = MESSAGES_ROUTE;

    #dialogService = inject(DialogService);
    constructor(public dialogRef: MatDialogRef<MessagesThreadListDialogComponent>) {
        super(dialogRef);
    }

    async openThreadInDialog(thread: Thread) {
        const { MessagesChatDialogComponent } = await import('../chat-dialog/chat-dialog.component');

        this.#dialogService.open<MessagesChatDialogComponent, MessagesChatDialogData>(MessagesChatDialogComponent, {
            width: '95%',
            height: '95%',
            maxWidth: '1000px',
            maxHeight: '800px',
            data: {
                thread,
            },
        });
    }
}
